angular.module("restaurants")

    .controller("RestaurantsListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state', 'datasetsService', function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state, datasetsService) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("RESTAURANTS_WRITE");
        $rootScope.title = $filter('translate')('restaurants.title');        
        $rootScope.breadcrumb = [
            { title: $filter('translate')('restaurants.title') }
        ];

        $scope.gridOptionsRestaurants = {
            pdfTitle: $filter('translate')('restaurants.title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,            
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('restaurants.name'), enableFiltering: true, enableHiding: false },
              { name: 'country_name', field: 'FK_restaurants_countries.name', displayName: $filter('translate')('restaurants.country'), enableFiltering: true, enableHiding: false },
              { name: 'state', displayName: $filter('translate')('restaurants.state'), enableFiltering: true, enableHiding: false },
              { name: 'city', displayName: $filter('translate')('restaurants.city'), enableFiltering: true, enableHiding: false },
              { name: 'phone_1', displayName: $filter('translate')('restaurants.phone'), enableFiltering: true, enableHiding: false },
              { name: 'email', displayName: $filter('translate')('restaurants.email'), enableFiltering: true, enableHiding: false },
              { name: 'address_line_1', displayName: $filter('translate')('restaurants.address'), enableFiltering: true, enableHiding: false },
              {
                  name: 'has_private_room', field: 'has_private_room', displayName: $filter('translate')('restaurants.private_room'),
                  filter: gridService.yesNoFilter('has_private_room'), width: 100, enableFiltering: true,
                  cellTemplate: gridService.yesNoTemplate('has_private_room')
              },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('restaurants.button_edit'), action: 'ui-sref="restaurants.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('restaurants.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {             
                return Restangular.all('Restaurants').getList(options)                        
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("restaurants.edit", { id: rowEntity.id });
        }


        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('restaurants.button_delete'),
                message: $filter('translate')('restaurants.delete_message') +" "+ $scope.name + "?",
                onAccept: function () {
                    Restangular.one('Restaurants', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('restaurants.delete_success'));
                        $scope.gridOptionsRestaurants.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

        $scope.export = function () {
            var options = {
                filters: {
                }
            };

            datasetsService.exportByType("restaurants", options);
        };
        
    }])

;